import { apiClient } from '../api-client'
import { type TokenEntity, type Auth0LoginInfoDto } from '../aspida/@types'

import {
  LOCAL_STORAGE_ACCESS_TOKEN_KEY,
  LOCAL_STORAGE_REFRESH_TOKEN_KEY
} from './constants'

export const loginWithAuth0 = async (
  body: Auth0LoginInfoDto
): Promise<TokenEntity> => {
  const { data } = await apiClient.auth.login_with_auth0.$post({
    body
  })
  localStorage.setItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY, data.accessToken)
  localStorage.setItem(LOCAL_STORAGE_REFRESH_TOKEN_KEY, data.refreshToken)
  return data
}
